import React from "react";
import _ from "lodash";

import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";

import WarningTooltip from "../../../../../../components/WarningTooltip";
import SelectFormElement
  from "../../../../../RiskProfiling/components/StepContent/components/formElement/SelectFormElement";

import styles from './styles';


const TradingDepotDiscountSelect = ({classes, portfolio, handleDepotDiscountChange}) => {
  return (
    <>
      {_.get(portfolio, 'ordering_discounts_allowed', []).includes('depot') && (
        <Grid item xs={'auto'} style={{marginLeft: 'auto'}}>
          <Grid container alignItems={"center"} spacing={1}>
            <Grid item>
              Depotrabatt
              {portfolio.combinedDiscounts && <WarningTooltip title={"Der ausgewählte Depotrabatt wird auf alle im depotbefindlichen Produkte angewendet. Der Depotrabatt bleibt dauerhaft auf Produktebene aktiv und gilt für alle zukünftigen Transaktionen, es sei denn, er wird geändert. Zusätzlich kann ein Einmalrabatt auf Produktebene vergeben werden. Der Depotrabatt und der Einmalrabatt werden addiert zum Gesamtrabatt auf Produktebene der jeweiligen Transaktion."}/>}
            </Grid>
            <Grid item>
              <SelectFormElement
                value={portfolio.discount}
                options={portfolio.availableDiscounts || []}
                onChange={handleDepotDiscountChange}
                custom_classes={{inputRoot: classes.depotDiscountInput}}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  )
};

export default withStyles(styles)(TradingDepotDiscountSelect);
